module.exports = __webpack_public_path__ + "img/treatment-history-tab-icon.f230ea3c.svg";